/*
  eslint-disable flights/no-use-effect-in-controller
  -- this line was auto generated, hence fix the issue timely
*/
import { useCallback, useEffect, useMemo, useRef } from "react";
import { useI18n, t } from "@bookingcom/lingojs-react";
import useTrackViAA from "../../../hooks/useTrackViAA";
import useIsInViewport from "../../../hooks/useIsInViewport";
import { UIFlightData } from "@flights/types";
import { SBSearchType } from "@bookingcom/flights-searchbox";
import { FrameProps } from "../Frame";
import { useStickySearchBoxExp } from "../../../utils/experiments/mdotvalue/flights_mdotvalue_sr_sticky_search_box";

export type FlightCardControllerProps = {
  flight: UIFlightData;
  onClick: (flight: UIFlightData) => void;
  pricePerPerson: boolean;
  index: number;
  bigLogo?: boolean;
  searchType?: SBSearchType;
  mt?: FrameProps["mt"];
  mb?: FrameProps["mb"];
  isAlternativeFareCard?: boolean;
  forceHideLastAvailableSeats?: boolean;
};

export default function useFlightCardController(props: FlightCardControllerProps) {
  const { bigLogo, flight, forceHideLastAvailableSeats, index, isAlternativeFareCard, mb, mt, onClick, searchType } =
    props;
  const i18n = useI18n();
  const { trackScrollToThird, trackScrollToFifth } = useStickySearchBoxExp(); //@exp flights_mdotvalue_sr_sticky_search_box

  //@start flights_mdotvalue_sr_sticky_search_box flights_web_aa_virtual_interlining_tracking
  const ref = useRef<HTMLDivElement>(null);
  const isInViewport = useIsInViewport(ref.current);
  //@end flights_mdotvalue_sr_sticky_search_box flights_web_aa_virtual_interlining_tracking

  // flights_web_aa_virtual_interlining_tracking -- start
  const trackViAA = useTrackViAA();
  useEffect(() => {
    trackViAA.ViAAInStage1();
    if (!isInViewport) return;
    trackViAA.ViAAInStage2(flight);
  }, [isInViewport, trackViAA, flight]);
  // flights_web_aa_virtual_interlining_tracking -- end

  //@start flights_mdotvalue_sr_sticky_search_box
  useEffect(() => {
    if (isInViewport && index === 3) {
      trackScrollToThird();
    } else if (isInViewport && index === 5) {
      trackScrollToFifth();
    }
  }, [index, isInViewport, trackScrollToFifth, trackScrollToThird]);
  //@end flights_mdotvalue_sr_sticky_search_box

  const handleOnClick = useCallback(() => {
    trackViAA.ViAAInStage3(flight);
    trackViAA.ViAAInStage4(flight);
    onClick(flight);
  }, [flight, onClick, trackViAA]);

  const ariaLabel = useMemo(() => i18n.trans(t("a11y_flights_search_card_begin")), [i18n]);

  return {
    ariaLabel,
    bigLogo,
    flight,
    forceHideLastAvailableSeats,
    handleOnClick,
    index,
    isAlternativeFareCard,
    mb,
    mt,
    ref,
    searchType
  };
}
